import { render, staticRenderFns } from "./upload-video.vue?vue&type=template&id=2ff34b14&scoped=true&"
import script from "./upload-video.vue?vue&type=script&lang=js&"
export * from "./upload-video.vue?vue&type=script&lang=js&"
import style0 from "./upload-video.vue?vue&type=style&index=0&id=2ff34b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff34b14",
  null
  
)

export default component.exports